import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/stamping.png'

function StampingNode() {
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={armLogo} alt="Stamping Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b className="text-nowrap">Stamping</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default StampingNode
